import React from 'react';
import { SelectOptions } from 'components/commonType';
import {
  CreativeFormBasicData,
  CreativeFormData,
  FormContentModel,
} from './FlowSteps/SubSteps/FormContent/FormContentModel';
import { CreativeType } from 'core/creative/Creative';

export type CreativeSetupFlowDataContextType = {
  creative: any;
  initCreative: any;
  advertisers: Array<SelectOptions>;
  supportedCreativeType: Array<CreativeType>;
  setCreative(creative: CreativeFormData): void;
  setFinishedRedirectData(data?: { pathname: string; state?: any }): void;
  getFormContentModelOfType(cretiveType: CreativeType): FormContentModel;
  getSummaryModel(creativeBasicFormData: CreativeFormBasicData);
};

export const CreativeSetupFlowDataContext =
  React.createContext<CreativeSetupFlowDataContextType>({
    initCreative: {},
    creative: {},
    advertisers: [],
    supportedCreativeType: [],
    setCreative: () => {
      // This is intentional
    },
    setFinishedRedirectData: () => {
      // This is intentional
    },
    getFormContentModelOfType: () => {
      throw new Error('Not implemented');
    },
    getSummaryModel: () => {
      // This is intentional
    },
  });
